import React, { useEffect, useState } from "react";
import styles from "../../topology.module.scss";
import { Form, Select, InputNumber, Row, Col, Input, Divider, Tag, Radio, RadioChangeEvent, FormInstance } from "antd";
import { CountryCodeData } from "./_countryCode";
import { CharacterVerify, basicRequire } from "Utility/RegExp";
import { useAppSelector } from "store/hook";
import { setFields, SSIDtags, VLANOptions, ap_mode, authoptions } from "./setFields";

const { Option } = Select;
const { CheckableTag } = Tag;

const BulkConfigFWifi_M350 = React.memo(
  ({ SubmitConfigonFinish, form }: { SubmitConfigonFinish: (value: any) => void; form: FormInstance<any> }) => {
    const { formData, importSource } = useAppSelector((state) => state.topology);
    const [SelectedWPS, setSelectedWPS] = useState("SSID-1");
    const [APTag, setAPTag] = useState("2.4G");
    const [SelectedCountryCode, setSelectedCountryCode] = useState<undefined | any[]>(undefined);
    const [ReykeyNumber1, setReykeyNumber1] = useState<any>({
      value: 0,
      errorMsg: "",
      validateStatus: undefined,
    });
    const [Wifi1_auth, setWifi1_auth] = useState("");
    const [Wifi2_auth, setWifi2_auth] = useState("");
    const [ReykeyNumber2, setReykeyNumber2] = useState<any>({
      value: 0,
      errorMsg: "",
      validateStatus: undefined,
    });

    const onChange = (e: RadioChangeEvent) => {
      setAPTag(e.target.value);
    };

    useEffect(() => {
      setSelectedCountryCode(CountryCodeData.filter((item) => item.val === formData?.wifi?.wifi_config?.CountryCode));
      setWifi1_auth(formData?.wifi?.wifi_config?.port?.[0]?.security?.wpa?.auth || "None");
      setWifi2_auth(formData?.wifi?.wifi_config?.port?.[1]?.security?.wpa?.auth || "None");

      //折疊的form再打開時會重新setField到舊的資料, 避免Import後 NewConfig又看到舊資料
      if (importSource === "NewConfig") {
        return;
      }
      const wifi = formData?.wifi;

      setFields(wifi, form);

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    function handleTagChange(value: string) {
      setSelectedWPS(value);
    }

    function validateKeyUpdate(number: number) {
      if (number === 0 || (30 <= number && number <= 86400)) {
        return {
          validateStatus: "success",
          errorMsg: "",
        };
      }

      return {
        validateStatus: "error",
        errorMsg: "0:no update, or 30-86400(sec)",
      };
    }

    const onRekeyChange1 = (value: number) => {
      const validateKeyUpdateResult: { validateStatus: string | undefined; errorMsg: string } =
        validateKeyUpdate(value);
      setReykeyNumber1({ ...validateKeyUpdateResult, value });
    };

    const onReykeyChange2 = (value: number) => {
      const validateKeyUpdateResult2: { validateStatus: string | undefined; errorMsg: string } =
        validateKeyUpdate(value);
      setReykeyNumber2({ ...validateKeyUpdateResult2, value });
    };

    return (
      <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
        <div className="formwrap">
          <Row gutter={24} justify="space-around">
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
              <h2>Mode</h2>
              <Divider className={styles.divider} />
              <Form.Item
                name={"Wifi_ap_mode"}
                label="WiFi AP Mode"
                // className={styles.FormItem}
                rules={[basicRequire]}
              >
                <Select>
                  {ap_mode.map((item) => (
                    <Option key={item} value={item}>
                      {item.toUpperCase()}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Radio.Group
                className="mt-4"
                onChange={onChange}
                style={{ marginBottom: 16, padding: 0 }}
                defaultValue={"2.4G"}
              >
                <Radio.Button value={"2.4G"}>2.4G</Radio.Button>
                <Radio.Button value={"5G"}>5G</Radio.Button>
              </Radio.Group>
            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}></Col>
          </Row>

          <div className={APTag === "2.4G" ? "block" : "hidden"}>
            <Row gutter={24} justify="space-around">
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                <h2>Network Config</h2>
                <Divider className={styles.divider} />
                <Row gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name={"Wifi1_ap_enable"}
                      label="AP Enable"
                      // className={styles.FormItem}
                      rules={[basicRequire]}
                      initialValue={true}
                      // tooltip={"Turn ON/OFF all WiFi Network."}
                    >
                      <Select placeholder={"ON/OFF"}>
                        {/* @ts-ignore */}

                        <Option key={0} value={true}>
                          ON
                        </Option>
                        {/* @ts-ignore */}

                        <Option key={1} value={false}>
                          OFF
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name={"Wifi1_txpower"}
                      label="Tx Power"
                      rules={[basicRequire]}
                      initialValue={100}
                      // tooltip={"The TX power setting specifies the strength of the signal."}
                    >
                      <InputNumber style={{ width: "100%" }} placeholder="1~100" min={1} max={100} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                <h2>SSID</h2>
                <Divider className={styles.divider} />
                {SSIDtags.map((tag) => (
                  <CheckableTag
                    key={tag}
                    checked={SelectedWPS.indexOf(tag) > -1}
                    onChange={() => handleTagChange(tag)}
                    // className={styles.SSIDtag}
                  >
                    {tag}
                  </CheckableTag>
                ))}

                {/* SSID-1 */}

                <Form.Item
                  name={"Wifi1_ap_isolate"}
                  label="Isolate"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  initialValue={false}
                  // tooltip={
                  //   "Isolation is a technique for preventing mobile devices connected to an AP from communicating directly with each other."
                  // }
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi1_CountryCode"}
                  label="Country Code"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  // tooltip={"Select Country Area for supported Channels."}
                >
                  <Select
                    onChange={(value) => {
                      let SelectedCountryCode = CountryCodeData.filter((item) => item.val === value);

                      setSelectedCountryCode(SelectedCountryCode);
                    }}
                    placeholder={"Select a country"}
                  >
                    {CountryCodeData.map((item, index) => (
                      <Option key={index} value={item.val}>
                        {item.Code} - {item.Country}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name={"Wifi1_channel_id"}
                  label="Channel"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                >
                  <Select placeholder={"Select a Channel"}>
                    {SelectedCountryCode?.[0]?.channel_ids?.map((item: any, index: number) => (
                      <Option key={index} value={item}>
                        {item === 0 ? "Auto" : item}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi1_ssid"}
                  label="Name(SSID)"
                  rules={[basicRequire, CharacterVerify]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  // tooltip={"SSID is WiFi indentification. The maximum length is 32."}
                >
                  <Input placeholder={"Name"} maxLength={32} />
                </Form.Item>

                <Form.Item
                  name={"Wifi1_hidden_ssid"}
                  label="Hidden SSID"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  initialValue={false}
                  // tooltip={"SSID hiding is the process of hiding the network name from being publicly broadcast."}
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi1_auth"}
                  label="Encryption"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  initialValue={"None"}
                >
                  <Select
                    placeholder={"None/WPA2-PSK-AES"}
                    onChange={(value: string) => {
                      setWifi1_auth(value);
                      form.validateFields(["Wifi1_passphrase"]);
                    }}
                  >
                    <Option key={0} value={"None"}>
                      None
                    </Option>
                    <Option key={1} value={"WPA2-PSK-AES"}>
                      WPA2-PSK-AES
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi1_passphrase"}
                  label="Passphrase"
                  rules={[
                    CharacterVerify,
                    {
                      pattern: /\w{8,63}/,
                      message: "Passphrase must be 8~63 characters or 8~64 HEX",
                    },
                    { required: Wifi1_auth !== "None", message: "required!" },
                  ]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  // tooltip={"Strings with a legal length of 8 to 63 or a length of 64 should belong to [0-9 A-F a-f]."}
                >
                  <Input.Password placeholder={"8~63 characters or 8~64 HEX"} autoComplete="new-password" />
                </Form.Item>

                <Form.Item
                  name={"Wifi1_rekey"}
                  label="Key Update"
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  validateStatus={ReykeyNumber1.validateStatus}
                  help={ReykeyNumber1.errorMsg}
                  rules={[basicRequire]}
                  initialValue={0}
                  // tooltip={
                  //   <Fragment>
                  //     {" "}
                  //     <p>0:no update</p> <p>30~86400 seconds update period.</p>{" "}
                  //   </Fragment>
                  // }
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder={"0 no update, or 30~86400(sec)"}
                    min={0}
                    max={86400}
                    value={ReykeyNumber1.value}
                    onChange={onRekeyChange1}
                  />
                </Form.Item>

                <Form.Item
                  name={"Wifi1_vlan"}
                  label="VLAN Subnet"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  tooltip={"Select the VLAN Subnet you want to bind."}
                >
                  <Select placeholder={"Net1-8"}>
                    {VLANOptions.map((item, index) => (
                      <Option key={index} value={item.value}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* SSID-2 */}

                <Form.Item
                  name={"Wifi2_enable"}
                  label="Enable"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  initialValue={false}
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi2_ap_isolate"}
                  label="Isolate"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  initialValue={false}
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi2_ssid"}
                  label="Name(SSID)"
                  rules={[basicRequire, CharacterVerify]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                >
                  <Input placeholder={"Name"} maxLength={30} />
                </Form.Item>

                <Form.Item
                  name={"Wifi2_hidden_ssid"}
                  label="Hidden SSID"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  initialValue={false}
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi2_auth"}
                  label="Encryption"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  initialValue={"None"}
                >
                  <Select
                    placeholder={"None/WPA2-PSK-AES"}
                    onChange={(value: string) => {
                      setWifi2_auth(value);
                      form.validateFields(["Wifi2_passphrase"]);
                    }}
                  >
                    {authoptions.map((opt) => (
                      <Option key={opt} value={opt}>
                        {opt}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi2_passphrase"}
                  label="Passphrase"
                  rules={[
                    CharacterVerify,
                    {
                      pattern: /\w{8,63}/,
                      message: "Passphrase must be 8~63 characters or 8~64 HEX",
                    },
                    {
                      required: Wifi2_auth !== "None",
                      message: "required!!",
                    },
                  ]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                >
                  <Input.Password placeholder={"8~63 characters or 8~64 HEX"} autoComplete="new-password" />
                </Form.Item>

                <Form.Item
                  name={"Wifi2_rekey"}
                  label="Key Update"
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  validateStatus={ReykeyNumber2.validateStatus}
                  help={ReykeyNumber2.errorMsg}
                  initialValue={0}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder={"0 no update, or 30~86400(sec)"}
                    min={0}
                    max={86400}
                    value={ReykeyNumber2.value}
                    onChange={onReykeyChange2}
                  />
                </Form.Item>
                <Form.Item
                  name={"Wifi2_vlan"}
                  label="VLAN Subnet"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                >
                  <Select placeholder={"Net1-8"}>
                    {VLANOptions.map((item, index) => (
                      <Option key={index} value={item.value}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className={APTag === "5G" ? "block" : "hidden"}>
            <Row gutter={24} justify="space-around">
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                <h2>Network Config</h2>
                <Divider className={styles.divider} />
                <Row gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name={"Wifi_5g_ap_enable"}
                      label="AP Enable"
                      className={styles.FormItem}
                      rules={[basicRequire]}
                      initialValue={true}
                      tooltip={"Turn ON/OFF all WiFi Network."}
                    >
                      <Select placeholder={"ON/OFF"}>
                        {/* @ts-ignore */}
                        {/* @ts-ignore */}
                        <Option key={0} value={true}>
                          ON
                        </Option>
                        {/* @ts-ignore */}
                        {/* @ts-ignore */}
                        <Option key={1} value={false}>
                          OFF
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name={"Wifi_5g_txpower"}
                      label="Tx Power"
                      rules={[basicRequire]}
                      initialValue={100}
                      // tooltip={"The TX power setting specifies the strength of the signal."}
                    >
                      <InputNumber style={{ width: "100%" }} placeholder="1~100" min={1} max={100} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                <h2>SSID</h2>
                <Divider className={styles.divider} />
                {SSIDtags.map((tag) => (
                  <CheckableTag
                    key={tag}
                    checked={SelectedWPS.indexOf(tag) > -1}
                    onChange={() => handleTagChange(tag)}
                    className={styles.SSIDtag}
                  >
                    {tag}
                  </CheckableTag>
                ))}

                {/* SSID-1 */}

                <Form.Item
                  name={"Wifi1_5g_ap_isolate"}
                  label="Isolate"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  initialValue={false}
                  // tooltip={
                  //   "Isolation is a technique for preventing mobile devices connected to an AP from communicating directly with each other."
                  // }
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi_5g_btw"}
                  label="HT Mode"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  initialValue={"20M"}
                  // tooltip={
                  //   <Fragment>
                  //     <p>20M: Only 20MHz Operation is Supported,40M: Both 20MHz and</p>{" "}
                  //     <p>40MHz Operation is Supported.</p>
                  //   </Fragment>
                  // }
                >
                  <Select placeholder={"20M/40M/80M"}>
                    <Option key={0} value={"20M"}>
                      20M
                    </Option>
                    <Option key={1} value={"40M"}>
                      40M
                    </Option>
                    <Option key={1} value={"80M"}>
                      80M
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi_5g_CountryCode"}
                  label="Country Code"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  // tooltip={"Select Country Area for supported Channels."}
                >
                  <Select
                    onChange={(value) => {
                      let SelectedCountryCode = CountryCodeData.filter((item) => item.val === value);

                      setSelectedCountryCode(SelectedCountryCode);
                    }}
                    placeholder={"Select a country"}
                  >
                    {CountryCodeData.map((item, index) => (
                      <Option key={index} value={item.val}>
                        {item.Code} - {item.Country}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name={"Wifi1_5g_channel_id"}
                  label="Channel"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                >
                  <Select placeholder={"Select a Channel"}>
                    {SelectedCountryCode?.[0]?.channel_ids?.map((item: any, index: number) => (
                      <Option key={index} value={item}>
                        {item === 0 ? "Auto" : item}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi1_5g_ssid"}
                  label="Name(SSID)"
                  rules={[basicRequire, CharacterVerify]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  // tooltip={"SSID is WiFi indentification. The maximum length is 32."}
                >
                  <Input placeholder={"Name"} maxLength={32} />
                </Form.Item>

                <Form.Item
                  name={"Wifi1_5g_hidden_ssid"}
                  label="Hidden SSID"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  initialValue={false}
                  tooltip={"SSID hiding is the process of hiding the network name from being publicly broadcast."}
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi1_5g_auth"}
                  label="Encryption"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  initialValue={"None"}
                >
                  <Select
                    placeholder={"None/WPA2-PSK-AES"}
                    onChange={(value: string) => {
                      setWifi1_auth(value);
                      form.validateFields(["Wifi1_5g_passphrase"]);
                    }}
                  >
                    {authoptions.map((opt) => (
                      <Option key={opt} value={opt}>
                        {opt}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi1_5g_passphrase"}
                  label="Passphrase"
                  rules={[
                    CharacterVerify,
                    {
                      pattern: /\w{8,63}/,
                      message: "Passphrase must be 8~63 characters or 8~64 HEX",
                    },
                    { required: Wifi1_auth !== "None", message: "required!" },
                  ]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  // tooltip={"Strings with a legal length of 8 to 63 or a length of 64 should belong to [0-9 A-F a-f]."}
                >
                  <Input.Password placeholder={"8~63 characters or 8~64 HEX"} autoComplete="new-password" />
                </Form.Item>

                <Form.Item
                  name={"Wifi1_5g_rekey"}
                  label="Key Update"
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  validateStatus={ReykeyNumber1.validateStatus}
                  help={ReykeyNumber1.errorMsg}
                  rules={[basicRequire]}
                  initialValue={0}
                  // tooltip={
                  //   <Fragment>
                  //     {" "}
                  //     <p>0:no update</p> <p>30~86400 seconds update period.</p>{" "}
                  //   </Fragment>
                  // }
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder={"0 no update, or 30~86400(sec)"}
                    min={0}
                    max={86400}
                    value={ReykeyNumber1.value}
                    onChange={onRekeyChange1}
                  />
                </Form.Item>

                <Form.Item
                  name={"Wifi1_5g_vlan"}
                  label="VLAN Subnet"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-1" ? { display: "none" } : {}}
                  // tooltip={"Select the VLAN Subnet you want to bind."}
                >
                  <Select placeholder={"Net1-8"}>
                    {VLANOptions.map((item, index) => (
                      <Option key={index} value={item.value}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* SSID-2 */}

                <Form.Item
                  name={"Wifi2_5g_enable"}
                  label="Enable"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  initialValue={false}
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi2_5g_ap_isolate"}
                  label="Isolate"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  initialValue={false}
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi2_5g_ssid"}
                  label="Name(SSID)"
                  rules={[basicRequire, CharacterVerify]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                >
                  <Input placeholder={"Name"} maxLength={30} />
                </Form.Item>

                <Form.Item
                  name={"Wifi2_5g_hidden_ssid"}
                  label="Hidden SSID"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  initialValue={false}
                >
                  <Select placeholder={"ON/OFF"}>
                    {/* @ts-ignore */}
                    <Option key={0} value={true}>
                      ON
                    </Option>
                    {/* @ts-ignore */}
                    <Option key={1} value={false}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi2_5g_auth"}
                  label="Encryption"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  initialValue={"None"}
                >
                  <Select
                    placeholder={"None/WPA2-PSK-AES"}
                    onChange={(value: string) => {
                      setWifi2_auth(value);
                      form.validateFields(["Wifi2_5g_passphrase"]);
                    }}
                  >
                    <Option key={0} value={"None"}>
                      None
                    </Option>
                    <Option key={1} value={"WPA2-PSK-AES"}>
                      WPA2-PSK-AES
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name={"Wifi2_5g_passphrase"}
                  label="Passphrase"
                  rules={[
                    CharacterVerify,
                    {
                      pattern: /\w{8,63}/,
                      message: "Passphrase must be 8~63 characters or 8~64 HEX",
                    },
                    {
                      required: Wifi2_auth !== "None",
                      message: "required!!",
                    },
                  ]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                >
                  <Input.Password placeholder={"8~63 characters or 8~64 HEX"} autoComplete="new-password" />
                </Form.Item>

                <Form.Item
                  name={"Wifi2_5g_rekey"}
                  label="Key Update"
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                  validateStatus={ReykeyNumber2.validateStatus}
                  help={ReykeyNumber2.errorMsg}
                  initialValue={0}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder={"0 no update, or 30~86400(sec)"}
                    min={0}
                    max={86400}
                    value={ReykeyNumber2.value}
                    onChange={onReykeyChange2}
                  />
                </Form.Item>
                <Form.Item
                  name={"Wifi2_5g_vlan"}
                  label="VLAN Subnet"
                  rules={[basicRequire]}
                  style={SelectedWPS !== "SSID-2" ? { display: "none" } : {}}
                >
                  <Select placeholder={"Net1-8"}>
                    {VLANOptions.map((item, index) => (
                      <Option key={index} value={item.value}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    );
  }
);

export default BulkConfigFWifi_M350;

////////////////////////////////////////////////////////

export function assemble(values: any) {
  //Wifi1
  let wpaObj1: any = {};
  if (values.Wifi1_auth) {
    wpaObj1.auth = values.Wifi1_auth;
  }

  wpaObj1.rekey = values.Wifi1_rekey || 0;
  if (values.Wifi1_passphrase) {
    wpaObj1.passphrase = values.Wifi1_passphrase;
  }

  let wpaObj2: any = {};
  if (values.Wifi2_auth) {
    wpaObj2.auth = values.Wifi2_auth;
  }

  wpaObj2.rekey = values.Wifi2_rekey || 0;
  if (values.Wifi2_passphrase) {
    wpaObj2.passphrase = values.Wifi2_passphrase;
  }

  //Wifi1_5G
  let wpaObj1_5g: any = {};
  if (values.Wifi1_5g_auth) {
    wpaObj1_5g.auth = values.Wifi1_5g_auth;
  }

  wpaObj1_5g.rekey = values.Wifi1_5g_rekey || 0;
  if (values.Wifi1_5g_passphrase) {
    wpaObj1_5g.passphrase = values.Wifi1_5g_passphrase;
  }

  let wpaObj2_5g: any = {};
  if (values.Wifi2_5g_auth) {
    wpaObj2_5g.auth = values.Wifi2_5g_auth;
  }

  wpaObj2_5g.rekey = values.Wifi2_5g_rekey || 0;
  if (values.Wifi2_5g_passphrase) {
    wpaObj2_5g.passphrase = values.Wifi2_5g_passphrase;
  }

  const wifiObj = {
    wifi_ap_mode: { ap_mode: values.Wifi_ap_mode },
    wifi_config: {
      ap_enable: values.Wifi1_ap_enable,
      txpower: values.Wifi1_txpower,
      CountryCode: values.Wifi1_CountryCode,
      port: [
        {
          basic: {
            enable: values.Wifi1_enable || true,
            ssid: values.Wifi1_ssid,
            hidden_ssid: values.Wifi1_hidden_ssid,
            channel_id: values.Wifi1_channel_id,
            ap_isolate: values.Wifi1_ap_isolate,
            vlan: values.Wifi1_vlan,
          },
          security: {
            wpa: wpaObj1,
          },
        },
        {
          basic: {
            enable: values.Wifi2_enable,
            ssid: values.Wifi2_ssid,
            hidden_ssid: values.Wifi2_hidden_ssid,
            channel_id: values.Wifi2_channel_id || 0,
            ap_isolate: values.Wifi2_ap_isolate,
            vlan: values.Wifi2_vlan,
          },
          security: {
            wpa: wpaObj2,
          },
        },
      ],
    },
    wifi_config_5g: {
      ap_enable: values.Wifi_5g_ap_enable,
      txpower: values.Wifi_5g_txpower,
      btw: values.Wifi_5g_btw,
      CountryCode: values.Wifi_5g_CountryCode,
      port: [
        {
          basic: {
            enable: values.Wifi1_5g_enable || true,
            ssid: values.Wifi1_5g_ssid,
            hidden_ssid: values.Wifi1_5g_hidden_ssid,
            channel_id: values.Wifi1_5g_channel_id,
            ap_isolate: values.Wifi1_5g_ap_isolate,
            vlan: values.Wifi1_5g_vlan,
          },
          security: {
            wpa: wpaObj1_5g,
          },
        },
        {
          basic: {
            enable: values.Wifi2_5g_enable,
            ssid: values.Wifi2_5g_ssid,
            hidden_ssid: values.Wifi2_5g_hidden_ssid,
            channel_id: values.Wifi2_5g_channel_id || 0,
            ap_isolate: values.Wifi2_5g_ap_isolate,
            vlan: values.Wifi2_5g_vlan,
          },
          security: {
            wpa: wpaObj2_5g,
          },
        },
      ],
    },
  };

  return wifiObj;
}
